import BackIcon from '@/assets/icon/BackIcon.vue'
import CalendarIcon from '@/assets/icon/CalendarIcon.vue'
import EditIcon from '@/assets/icon/EditIcon.vue'
import FolderIcon from '@/assets/icon/FolderIcon.vue'
import PlusIcon from '@/assets/icon/PlusIcon.vue'
import SearchIcon from '@/assets/icon/SearchIcon.vue'
import UserIcon from '@/assets/icon/UserIcon.vue'
import ClockIcon from '@/assets/icon/ClockIcon.vue'
import NextIcon from '@/assets/icon/NextIcon.vue'
import HomeProductsIcon from '@/assets/icon/HomeProductsIcon.vue'
import HomeStudyIcon from '@/assets/icon/HomeStudyIcon.vue'
import CrownProfile from '@/assets/icon/CrownProfile.vue'
import CheckIcon from '@/assets/icon/CheckIcon.vue'
import CircleCancelIcon from '@/assets/icon/CircleCancelIcon.vue'
import CircleExclamationIcon from '@/assets/icon/CircleExclamationIcon.vue'
import TelegramIcon from '@/assets/icon/TelegramIcon.vue'
import InfoIcon from '@/assets/icon/InfoIcon.vue'
import CloseIcon from '@/assets/icon/CloseIcon.vue'
import CardIcon from '@/assets/icon/CardIcon.vue'
import CancelIcon from '@/assets/icon/CancelIcon.vue'
import WarningIcon from '@/assets/icon/WarningIcon.vue'
import BookIcon from "@/assets/icon/BookIcon.vue";

const icons = {
  homeProducts: HomeProductsIcon,
  homeStudy: HomeStudyIcon,
  //
  circleCancel: CircleCancelIcon,
  circleExclamation: CircleExclamationIcon,
  //
  back: BackIcon,
  calendar: CalendarIcon,
  edit: EditIcon,
  folder: FolderIcon,
  plus: PlusIcon,
  search: SearchIcon,
  user: UserIcon,
  clock: ClockIcon,
  next: NextIcon,
  card: CardIcon,
  cancel: CancelIcon,
  warning: WarningIcon,
  book: BookIcon,
  CrownProfile,
  CheckIcon,
  TelegramIcon,
  InfoIcon,
  CloseIcon,

}

export {icons}
